/* unplugin-vue-components disabled */import script from "./EventsPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./EventsPopup.vue?vue&type=script&setup=true&lang=js"

import "./EventsPopup.vue?vue&type=style&index=0&id=f4bfd92c&lang=scss"
import "./EventsPopup.vue?vue&type=style&index=1&id=f4bfd92c&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f4bfd92c"]])

export default __exports__